import useResolutionContent from "@/lib/resolutions/use-resolution-content";
import { Badge } from "@babackapp/ui/components/badge";
import { ChevronDown } from "lucide-react";
import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type ReturnArticleResolutionProps = {
  resolution?: ReturnRequestLineItemDto["resolution"];
  editable?: boolean;
};

export default function ReturnArticleResolution({
  resolution,
  editable,
}: ReturnArticleResolutionProps) {
  const resolutionContent = useResolutionContent(resolution);

  if (!resolution || !resolutionContent) return null;

  return (
    <Badge variant="secondary" className="inline-flex gap-1" size="sm">
      <resolutionContent.Icon className="size-4" />
      {resolutionContent?.label}
      {editable && (
        <span className={"underline-offset-2 inline-flex items-center gap-1"}>
          <ChevronDown className="size-3" />
        </span>
      )}
    </Badge>
  );
}
